module.exports = __webpack_public_path__ + "img/bg-back.93dc9216.png";